'use strict';

// Script has differences #CDIFF #MONITOR BS <> GG <> PF <> SN <> FM
// Current version is BS-based with delta sync from other site-specific versions.
// SN app cartridge does not quick view script.

var quickView = require('base/product/quickView');

var base = require('theme/js/product/base');
var gtmDataLayer = require('theme/js/analytics/gtmDataLayer');
import siteConfig from 'shared/js/siteConfig';
import { renderTurnstileWidget } from 'shared/js/turnstileWidget';
import { VOYADO_EVENT_TRACK_PRODUCT_IMPRESSION } from 'shared/js/voyadoEventNames';
import quantityHelper from 'shared/js/quantityHelper';

const Swiper = window.Swiper;

/**
 * Adds a notification to the cart box that an item has been added to the cart.
 *
 * @param {string} productName - The name of the product that was added to the cart.
 * @param {string} addToCartMsg - The message to display along with the product name.
 */
function showAddToCartNotification(productName, addToCartMsg) {
    $('.cart-box-items').append('<div class="cart-box-item">'
        + '<div class="cart-box-item-icon"><i class="icon-check"></i></div>'
        + '<div class="cart-box-item-title">'
        + '<span class="cart-box-item-title-name">'
        + productName
        + '</span>'
        + '<span class="cart-box-item-title-name-msg">' + addToCartMsg
        + '</span>'
        + '</div>'
        + '</div>');
}

// The next two functions:
// - showPreMinicartBox
// - showCartItemsHeader
// are migrated from ./detail.js for "updateQuantity" and "showPreMinicart", see those functions for more info.
function showPreMinicartBox(response) {
    $('.header').removeClass('scroll-down');
    $('.cart-box-items').empty();
    $('.cart-box-free-delivery-msg').empty();

    var firstBonusProductAddedToTheCart = response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0 && response.previousBonusDiscountLineItemsLength == 0;
    if (!firstBonusProductAddedToTheCart || response.addedBonusItems) {
        var $show = $('.added-to-cart-box').show();
        setTimeout(function () {
            $show.hide();
        }, 3000);
    }

    $('.minicart .minicart-quantity').html(response.quantityTotal);
    if (response.error) {
        $('.cart-box-items').append('<div class="cart-box-item">'
            + '<div class="cart-box-item-icon"><i class="icon-check"></i></div>'
            + '<div class="cart-box-item-title">'
            + '<span class="cart-box-item-title-name">'
            + response.message
            + '</span>'
            + '</div>'
            + '</div>');
    } else {
        let quantumProductsAddedNames = [];
        response.cart.items.forEach(function (items) {
            if (response.quantumSelections && response.quantumSelectionsUUIDs) {
                if (response.quantumSelections.indexOf(items.id) > -1 && response.quantumSelectionsUUIDs.indexOf(items.UUID) > -1) {
                    quantumProductsAddedNames.push(items.productName);
                }
            } else if (response.pid == items.id && response.pliUUID == items.UUID) {
                showAddToCartNotification(items.productName, response.addToCartMsg);
            }
        });

        if (quantumProductsAddedNames.length > 0) {
            showAddToCartNotification(quantumProductsAddedNames.join(' & '), response.addToCartMsg);
        }

        if (response.addedBonusItems) {
            response.addedBonusItems.forEach(function (bonusProduct) {
                showAddToCartNotification(bonusProduct.name, response.addToCartMsg);
            });
        }

        // #CDIFF #DONE BS <> SN
        // SN does not have giftCertificateLineItemInCart & isFreeDeliveryEnabled check
        if (!siteConfig.isSite('SN')) {
            if (response.isFreeDeliveryEnabled == 'true' && !response.giftCertificateLineItemInCart) {
                if (response.leftToFreeDelivery > 0) {
                    $('.cart-box-free-delivery-msg').append('<div class="minicart-message msg-free-delivery">'
                        + '<strong>' + response.freeDeliveryMsg + '</strong>'
                        + '</div>');
                } else {
                    $('.cart-box-free-delivery-msg').append('<div class="minicart-message msg-free-delivery">'
                        + '<div class="cart-box-free-item-icon"><i class="icon-check"></i></div>'
                        + '<strong>' + response.freeDeliveryMsg + '</strong>'
                        + '</div>');
                }
            }
        }
    }

    if (response.cart.hasBonusProduct || response.displayBonusProductMessage) {
        $('.msg-bonus-product').show();
    }
}

/**
 * Updates the small box to show what is added to minicart after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */

function showCartItemsHeader() {
    $('.minicart-quantity').removeClass('empty-cart');
    $('.minicart .icon-cart').removeClass('empty-cart-trigger');
    $('.price-header').removeClass('empty-cart');
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="quickview-modal modal fade" id="quickViewModal" tabindex="-1" role="dialog" aria-modal="true">'
        + '<div class="quickview-modal-dialog modal-dialog quick-view-dialog" role="document">'
        + '<!-- Modal content-->'
        + '<div class="quickview-modal-content modal-content">'
        + '<div class="quickview-modal-header modal-header">'
        + '<button type="button" class="quickview-modal-close-button icon-close" data-dismiss="modal"></button>'
        + '</div>'
        + '<div class="quickview-modal-body modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');

    return { body: body };
}

/**
 * Init product carousel in quick view modal
 */
function initProductCarousel() {
    // Slides past the first are rendered hidden so only the LCP image is laid
    // out before Swiper boots. They have to be released before init, otherwise
    // Swiper measures them at zero width and the carousel collapses to one image.
    $('.product-quickview .product-carousel .swiper-slide').removeClass('hidden');

    var productSwiper = new Swiper('.product-quickview .product-carousel', {
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.product-quickview .product-carousel .swiper-button-next',
            prevEl: '.product-quickview .product-carousel .swiper-button-prev',
        },
    });

    $('.product-quickview .product-swatch-images .swatch').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).siblings('.active').removeClass('active');
            $(this).addClass('active');
            productSwiper.slideToLoop($(this).index(), 0);
        }
    });

    productSwiper.on('slideChange', function () {
        var productSwatchImages = $('.product-quickview .product-swatch-images .swatch');
        productSwatchImages.siblings('.active').removeClass('active');
        productSwatchImages.eq(productSwiper.realIndex).addClass('active');
    });

    gtmDataLayer.bindDesktopProductCarouselSwipe();
}

/**
 * Render Content Assets in Quick View
 */
function renderPdpContentAssets() {
    var $productUsps = $('#product-usps');
    var $pdpOutOfStockPopupConsent = $('#PDP-out-of-stock-popup-consent');
    var $pdpOutOfStockDisclaimer = $('#PDP-out-of-stock-disclaimer');

    if ($productUsps.length) {
        $('#quickViewModal .product-usps-container').html($productUsps.html());
    }
    if ($pdpOutOfStockPopupConsent.length) {
        $('#quickViewModal .PDP-out-of-stock-popup-consent-asset').html($pdpOutOfStockPopupConsent.html());
    }
    if ($pdpOutOfStockDisclaimer.length) {
        $('#quickViewModal .product-outofstock-disclaimer').html($pdpOutOfStockDisclaimer.html());
    }
}

function togglePopup() {
    $('.product-outofstock-popup-close, .product-outofstock-popup-cancel').click(function (e) {
        e.preventDefault();
        $('.product-outofstock-popup__container').addClass('hide');
    });

    $('button.notify-me').click(function () {
        $('.product-outofstock-popup__container').removeClass('hide');
        renderTurnstileWidget('.quickview-turnstile-widget');
        $('.product-outofstock-popup-submit-quick-view').click(function () {
            submitBackInStock();
        });
    });
}

/**
 * Names the dialog after the product heading and labels the close button (text rendered by quickView.isml).
 */
function setModalAccessibleNames() {
    var $modal = $('#quickViewModal');
    var $title = $modal.find('.product-name h1').first();

    if ($title.length) {
        $title.attr('id', 'quickview-modal-title');
        $modal.attr('aria-labelledby', 'quickview-modal-title');
    }

    $modal.find('.quickview-modal-close-button').attr('aria-label', $modal.find('.product-quickview').attr('data-close-label'));
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            $('#quickViewModal .modal-body').empty();
            $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .quickview.read-more, #quickViewModal .quickview-modal-product-name').attr('href', data.productUrl);
            $('#quickViewModal .quickview.read-more').on('click', function (e) {
                e.stopPropagation();
            });
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            setModalAccessibleNames();
            $('#quickViewModal').modal('show');

            var previewLabel = $.trim($('#quickViewModal a.quickview-modal-product-name h1').first().text()) || '';
            gtmDataLayer.push({
                event: 'pageInteraction',
                eventInfo: {
                    category: 'product list interactions',
                    action: 'product preview',
                    label: previewLabel
                }
            });

            renderPdpContentAssets();
            togglePopup();

            $('.product-outofstock-popup-close, .product-outofstock-popup-cancel').click(function (e) {
                e.preventDefault();
                $('.product-outofstock-popup__container').addClass('hide');
            });

            $('button.notify-me').click(function () {
                $('.product-outofstock-popup__container').removeClass('hide');
            });

            document.dispatchEvent(
                new CustomEvent(VOYADO_EVENT_TRACK_PRODUCT_IMPRESSION, {
                    detail: {
                        categoryName: $('#quickViewModal .breadcrumb').text().replace(/\n/g, '').replace(/\s+/g, ' ').trim(),
                        itemId: $('#quickViewModal #product-detail').data('pid'),
                        locale: window.currentLocale,
                        contactId: $('[data-voyado-contact-id]').data('voyado-contact-id')
                    }
                })
            );

            initProductCarousel();
            window.setWishlistState && window.setWishlistState(data.product.id);
        }
    });
}

function showAfterSubmitPopup() {
    $('.product-outofstock-popup-before-submit').addClass('hide');
    $('.product-outofstock-popup-after-submit').removeClass('hide');
}

/**
 * @private
 * @function
 * @description Submit an email on Back in Stock Popup
 */

function submitBackInStock() {
    var emailField = $('.product-outofstock-quickview');
    var emailInput = emailField.val();
    var pid = $('.product-outofstock-popup-pid-form-input').val();

    var regExp = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    var error = '';

    if (emailInput.length == 0) {
        error = 'this field is required';
    } else if (!emailInput.match(regExp)) {
        error = 'please enter a valid email';
    }
    if (!error && error.length == 0) {
        var turnstileResponse = emailField.parent().find('input[name="cf-turnstile-response"]');

        var params = {
            email: emailInput,
            pid: pid,
            'cf-turnstile-response': turnstileResponse.val(),
            action: 'backinstock'
        };

        var url = $('.product-outofstock-popup-submit-quick-view').data('url');

        $.ajax({
            type: 'POST',
            url: url,
            data: params,
            success: function () {
                $('.product-outofstock-popup-email-submit').html(emailInput);
                showAfterSubmitPopup();
                $('.back-in-stock__success').removeClass('hide');
            }
        });
    } else {
    // Email is empty or not valid - Show error
        $('.back-in-stock__error').removeClass('hide');
        $('.back-in-stock__error').text(error);
    }
    renderTurnstileWidget('.quickview-turnstile-widget');
}

function getQuantumProductContainer($el) {
    return $el.closest('.product-detail');
}

function quantumPriceUpdate($productContainer, tilesArray, tileInArray, productQuantity) {
    var pricePerProduct = tilesArray[tileInArray].attributes['data-price'].value;
    var percentagae = tilesArray[tileInArray].attributes['data-percentage'].value;
    var currency = tilesArray[tileInArray].attributes['data-currency'].value;
    var newPrice = productQuantity * (pricePerProduct * (1 - percentagae / 100)).toFixed(2);

    $productContainer.find('.prices-and-availability .price-sales').text(
        currency == '€' ? newPrice.toFixed(2) + ' ' + currency : Math.round(newPrice) + ' ' + currency
    );
}

function quantumUpdate($productContainer, productQuantity) {
    var tilesArray = $productContainer.find('.promotion-box-tile');
    var tilesLength = tilesArray.length;

    // Start from the highest tile so we don't duplicate calculations
    for (var i = tilesLength - 1; i >= 0; i--) {
        var tileQuantity = parseInt(tilesArray[i].getAttribute('data-quantity'), 10);

        if (productQuantity >= tileQuantity) {
            updateTile($productContainer, i);
            quantumPriceUpdate($productContainer, tilesArray, i, productQuantity);
            quantityHelper.cloneDropdownTiles($productContainer.find('.product-variations').first(), productQuantity);
            break;
        }
    }
}

function updateTile($productContainer, index) {
    $productContainer.find('.promotion-box-tile').removeClass('active');
    $productContainer.find('.promotion-box-tiles > .promotion-box-tile:nth-child(' + (index + 1) + ')').addClass('active');
}

/**
 * Writes the live quantity into the add-to-cart tracking payload.
 * @param {jQuery} $fromEl - element inside .quantity-and-add-to-cart
 * @param {number|string} quantity - quantity to record
 */
function syncAddToCartTrackingQuantity($fromEl, quantity) {
    var trackingPayload = $fromEl.closest('.quantity-and-add-to-cart').find('button.add-to-cart')[0];
    var trackingEventPayload = trackingPayload && trackingPayload.dataset.trackingEventPayload
        ? JSON.parse(trackingPayload.dataset.trackingEventPayload)
        : undefined;

    if (trackingEventPayload && trackingEventPayload.add && trackingEventPayload.add.products
        && trackingEventPayload.add.products[0]) {
        trackingEventPayload.add.products[0].quantity = parseInt(quantity, 10);
        trackingPayload.dataset.trackingEventPayload = JSON.stringify(trackingEventPayload);
    }
}

var lastFocusedElement;

/**
 * Matches Foundation show-for-large breakpoint used on PLP desktop quick view.
 * @returns {boolean}
 */
function isDesktopViewport() {
    return window.matchMedia('(min-width: 1024px)').matches;
}

/**
 * @returns {boolean}
 */
function isDesktopQuickViewEnabled() {
    return !(window.SitePreferences && window.SitePreferences.ENABLE_DESKTOP_QUICK_VIEW === false);
}

/**
 * Resolves PDP URL when desktop quick view is disabled.
 * @param {jQuery} $quickviewLink
 * @returns {string|undefined}
 */
function getProductUrlFromQuickViewLink($quickviewLink) {
    var href = $quickviewLink.attr('href');
    if (href && href !== '#' && href.indexOf('Product-ShowQuickView') === -1) {
        return href;
    }

    var quickViewUrl = $quickviewLink.attr('data-href') || href;
    if (quickViewUrl && quickViewUrl.indexOf('Product-ShowQuickView') !== -1) {
        return quickViewUrl.replace('Product-ShowQuickView', 'Product-Show');
    }

    var $tile = $quickviewLink.closest('.product-tile');
    var $productLink = $tile.find('a.product-tile-image-link[href]').filter(function () {
        return $(this).attr('href') && $(this).attr('href').indexOf('Product-ShowQuickView') === -1;
    }).first();

    if ($productLink.length) {
        return $productLink.attr('href');
    }

    return $tile.find('a[href*="Product-Show"]').not('.quickview').first().attr('href');
}

quickView.showQuickview = function () {
    $('body').on('click', '.quickview', function (e) {
        e.preventDefault();
        e.stopPropagation();
        lastFocusedElement = this;
        var $quickviewLink = $(this).closest('a.quickview');

        // data-quickview-force: always open as a popup (PDP add-on row, SFCC-3229)
        if (isDesktopViewport() && !isDesktopQuickViewEnabled() && !$quickviewLink.is('[data-quickview-force]')) {
            var productUrl = getProductUrlFromQuickViewLink($quickviewLink);
            if (productUrl) {
                window.location.href = productUrl;
            }
            return;
        }

        var selectedValueUrl;
        if (siteConfig.isSite('SN')) {
            // #CDIFF #DONE SN has just "href".
            selectedValueUrl = $quickviewLink.attr('href');
        } else {
            selectedValueUrl = $quickviewLink.attr('data-href');
        }
        $(e.target).trigger('quickview:show');
        getModalHtmlElement();
        fillModalElement(selectedValueUrl);
    });
};
if (siteConfig.isSite('GG')) {
    quickView.hideDialog = function () {
        $('body').on('product:afterAddToCart', function () {
            if ($('#quickViewModal').length > 0) {
                $('#quickViewModal').modal('hide');
            }
        });
    };
}

function hideQuickViewModal() {
    $('#quickViewModal').remove();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');

    if (lastFocusedElement) {
        lastFocusedElement.focus();
    }
}

quickView.hideQuickView = function () {
    $('body').on('click', '.quickview-modal-close-button', function () {
        if ($('#quickViewModal').length > 0) {
            hideQuickViewModal();
        }
    });

    $('body').on('product:afterAddToCart', function () {
        if ($('#quickViewModal').length > 0) {
            hideQuickViewModal();
        }
    });

    $('body').on('keydown', '.quickview-modal', function (e) {
        if (e.code == 'Escape') {
            if (lastFocusedElement) {
                lastFocusedElement.focus();
            }
        }
    });
};

// Do not duplicate callbacks already present in detail.js

// This function is migrated from detail.js script to avoid mess with duplicated callbacks.
// Quick view is loaded on all pages, while defining it in detail.js does not make it working on Quick View popup.
quickView.updateQuantity = function () {
    $('body').on('click', '[data-animation]', function (e) {
        e.preventDefault();
        var $productContainer = getQuantumProductContainer($(this));
        var productQuantityInput = $(this).siblings('.quantity-select');
        var quantity = productQuantityInput.val();
        var minOrderQuantity = parseInt(productQuantityInput.data('min-quantity')) || 1;
        var stepOrderQuantity = parseInt(productQuantityInput.data('step-quantity')) || 1;
        var productQuantity = parseInt(quantity, 10);
        var hasQuantum = $productContainer.find('.quantum').length;

        if ($(this).hasClass('increase-quantity')) {
            var newProductQuantity = productQuantity + stepOrderQuantity;

            if (hasQuantum) {
                newProductQuantity = quantityHelper.clampQuantumQuantity(
                    $productContainer,
                    productQuantityInput,
                    newProductQuantity
                );
            }

            productQuantityInput.val(newProductQuantity);

            if (productQuantity == minOrderQuantity) {
                $(this).siblings('.icon--disabled').attr('tabindex', 0).removeClass('icon--disabled');
            }

            if (hasQuantum) {
                quantumUpdate($productContainer, newProductQuantity);
            }
        } else if ($(this).hasClass('decrease-quantity') && quantity >= minOrderQuantity + stepOrderQuantity) {
            var newSubtractedQuantity = productQuantity - stepOrderQuantity;

            if (hasQuantum) {
                newSubtractedQuantity = quantityHelper.clampQuantumQuantity(
                    $productContainer,
                    productQuantityInput,
                    newSubtractedQuantity
                );
            }

            productQuantityInput.val(newSubtractedQuantity);

            if (newSubtractedQuantity == minOrderQuantity) {
                $(this).addClass('icon--disabled').attr('tabindex', -1);
            }

            if (hasQuantum) {
                quantumUpdate($productContainer, newSubtractedQuantity);
            }
        }

        syncAddToCartTrackingQuantity($(this), productQuantityInput.val());
    });

    $('body').on('change', '.quantity-select', function () {
        var $productContainer = getQuantumProductContainer($(this));
        var userInputQuantity = parseInt($(this).val(), 10);
        var hasQuantum = $productContainer.find('.quantum').length;

        if (hasQuantum) {
            userInputQuantity = quantityHelper.clampQuantumQuantity(
                $productContainer,
                $(this),
                userInputQuantity
            );
        }

        var minOrderQuantity = parseInt($(this).data('min-quantity')) || 1;
        var stepOrderQuantity = parseInt($(this).data('step-quantity')) || 1;
        var updatedQuantity;

        if (userInputQuantity <= minOrderQuantity) {
            updatedQuantity = minOrderQuantity;
            $(this).siblings('.decrease-quantity').addClass('icon--disabled').attr('tabindex', -1);
        } else if (stepOrderQuantity > 1) {
            if (userInputQuantity < minOrderQuantity + stepOrderQuantity) {
                updatedQuantity = minOrderQuantity;
            } else {
                var excessQuantity = (userInputQuantity - minOrderQuantity) % stepOrderQuantity;
                updatedQuantity = userInputQuantity - excessQuantity;
            }
        } else {
            updatedQuantity = userInputQuantity;
        }

        $(this).val(updatedQuantity);

        if (hasQuantum) {
            quantumUpdate($productContainer, updatedQuantity);
        }

        syncAddToCartTrackingQuantity($(this), updatedQuantity);
    });
};

// The same as with "quickView.updateQuantity" above - migrated from detail.js to fix duplicated callbacks.
quickView.showPreMinicart = function () {
    $('body').on('product:afterAddToCart', function (e, data) {
        if (data.productIsAdded || data.addedBonusItems) {
            showPreMinicartBox(data);
        }
        if (data.cart.items.length > 0) {
            showCartItemsHeader();
        }
        if (data.isDonationProduct) {
            $('[data-pid="' + data.pid + '"]').trigger('focus');
        }
    });
};

quickView.updateAvailability = function () {
    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available);

        var quickview = $('.quickview-modal').hasClass('show');
        if (quickview) {
            $('.quickview-modal .availability-msg', response.$productContainer)
                .empty().html(response.message);
        } else {
            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);
        }

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });
};

// Do not export remove "addToCart" from being exported there. It's used for callbacks on both PDP and Quick View.
quickView.addToCart = base.addToCart;
quickView.availability = base.availability;
quickView.colorAttribute = base.colorAttribute;
quickView.selectAttribute = base.selectAttribute;
quickView.removeBonusProduct = base.removeBonusProduct;
quickView.selectBonusProduct = base.selectBonusProduct;
quickView.enableBonusProductSelection = base.enableBonusProductSelection;
quickView.showMoreBonusProducts = base.showMoreBonusProducts;
quickView.addBonusProductsToCart = base.addBonusProductsToCart;
quickView.switchBonusProductsInCart = base.switchBonusProductsInCart;
quickView.focusChooseBonusProductModal = base.focusChooseBonusProductModal;
quickView.onClosingChooseBonusProductModal = base.onClosingChooseBonusProductModal;
quickView.trapChooseBonusProductModalFocus = base.trapChooseBonusProductModalFocus;
quickView.showHideBonusProductDescription = base.showHideBonusProductDescription;
quickView.enableBonusProductSwitch = base.enableBonusProductSwitch;

module.exports = quickView;
